"use client"

import { useState } from "react"
import { Check, Link2 } from "lucide-react"

export function ArticleShare() {
  const [message, setMessage] = useState("")
  const [copied, setCopied] = useState(false)
  async function copyLink() {
    try {
      await navigator.clipboard.writeText(`${window.location.origin}${window.location.pathname}`)
      setCopied(true)
      setMessage("Article link copied.")
    } catch { setMessage("Copy the article address from your browser to share it.") }
  }
  return <div><button type="button" onClick={copyLink}>{copied ? <Check size={15} aria-hidden="true" /> : <Link2 size={15} aria-hidden="true" />}{copied ? "Link copied" : "Copy article link"}</button><p role="status">{message}</p></div>
}
